import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import SubmitApplication from "~/views/submit-application"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const apiContext = await getApiContext(
    [{ url: "/procurementcategories/list" }],
    req ? req.headers.host : location.host,
  )

  const crumbs = generateCrumbs(req?.url)

  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
SubmitApplication.getInitialProps = getInitialProps

export default SubmitApplication
